import React from 'react';
import { Typography } from '@guildeducationinc/recess';

export const RecommendedProgramsHeader: React.FC = () => {
	return (
		<>
			<div className='aa-SourceHeaderTitle'>
				<Typography variant='label1'>Quiz recommended programs</Typography>
			</div>
			<div className='aa-SourceHeaderLine' />
		</>
	);
};
